import React, { useState, useRef, useEffect } from "react";
import "./FormationDiplomes.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FaCheck, FaPen, FaTrash } from "react-icons/fa";
import { InputText } from "primereact/inputtext";
import BtnEcouteMarche from "Components/Boutons/BtnEcouteMarche/BtnEcouteMarche";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import { Dropdown } from "primereact/dropdown";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { fr } from "date-fns/locale";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Checkbox } from "primereact/checkbox";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import BtnBlancLeft from "Components/Boutons/BtnBlancLeft/btn-blanc-left";
import BtnBleuLeft from "Components/Boutons/BtnBleuLeft/btn-bleu-left";
import { Toast } from "primereact/toast";
import crown from "assets/crown.png";
import {
  formatDateWihoutDays,
  changeOrderDate,
} from "../../../Services/functions";
import { fetchGet, useFetchGetConditional } from "Services/api";
import {
  updateEducation,
  updateCompletionLevel,
} from "Redux/Actions/authActions";
import BtnRetour from "Components/Boutons/BtnRetour/btn-retour";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";
import { fetchPut } from "Services/apiESA";
import { errorToast, successToast } from "Services/toastFunctions";

const FormationDiplomes = (props) => {
  const successUpdate = useRef(null);
  const domainData = useFetchGetConditional(
    "/domains",
    props.auth.token,
    props.secondaryTables.domainsData
  );
  const diplomaData = useFetchGetConditional(
    "/level_of_educations",
    props.auth.token,
    props.secondaryTables.levelOfEducationsData
  );

  const [errorMessageEndDate, setErrorMessageEndDate] = useState({
    message: "",
    index: null,
  });
  const [countForm, setCountForm] = useState(1);
  const [validated, setValidated] = useState(false);
  const [formations, setFormations] = useState(
    typeof props.auth.userConnected?.resume?.educations === "object"
      ? Object.values(props.auth.userConnected.resume.educations)
      : props.auth.userConnected?.resume?.educations
  );
  const [modified, setModified] = useState(false);

  // Liste des id des formations supprimées (lors de la prochaine requête PUT)
  const [deletedIds, setDeletedIds] = useState([]);

  useEffect(() => {
    diplomaData.loaded &&
      domainData.loaded &&
      props.handleUpdateSecondaryTables({
        levelOfEducationsData: diplomaData.data,
        domainsData: domainData.data,
      });
  }, [diplomaData.loaded, domainData.loaded]);

  const verifyDataInstance = (i) => {
    //? Si la formation est certifiée, pas besoin de vérifier les champs
    if (
      formations[i]?.certified ||
      ((formations[i].studyLevel != null || formations[i].studyLevel != "") &&
        (formations[i].diploma != null || formations[i].diploma != "") &&
        (formations[i].school != null || formations[i].school != "") &&
        (formations[i].domain != null || formations[i].domain != "") &&
        formations[i].startDate != null &&
        (formations[i].endDate != null || formations[i].current))
    ) {
      return true;
    }
    return false;
  };

  const verifyData = () => {
    setValidated(true);
    var verifiedData = true;
    for (let index = 0; index < formations.length; index++) {
      let check = verifyDataInstance(index);
      verifiedData = verifiedData ? check : false;
    }
    return verifiedData;
  };

  const checkFormationBeforeAdd = () => {
    let verifiedData = verifyData();
    addFormation(verifiedData);
  };

  const addFormation = (verifiedData) => {
    if (verifiedData) {
      const newFormation = {
        studyLevel: "",
        diploma: null,
        domain: null,
        school: "",
        startDate: null,
        endDate: null,
        current: false,
        city: "",
        idFormation: countForm,
      };
      setCountForm(countForm + 1);
      setFormations([...formations, newFormation]);
      setValidated(false);
    }
  };
  const majFormation = (e, i, champ) => {
    const newArray = [...formations];

    if (champ == "studyLevel") {
      newArray[i].studyLevel = e.target.value.label;
    }
    if (champ == "diploma") {
      newArray[i].diploma = e.target.value;
    }
    if (champ == "domain") {
      newArray[i].domain = e.target.value.label;
    }
    if (champ == "school") {
      newArray[i].school = e.target.value;
    }
    if (champ == "current") {
      newArray[i].current = e.checked;
    }
    if (champ == "startDate") {
      newArray[i].startDate = e;
    }
    if (champ == "endDate") {
      newArray[i].endDate = e;
    }
    if (champ == "city") {
      newArray[i].city = e.target.value;
    }
    setFormations(newArray);
    verifyData(i);
  };

  const supprFormation = (i, formationId) => {
    const newArray = [...formations];

    // Ajout de la formation à supprimer dans le tableau des id à supprimer
    if (formationId) setDeletedIds([...deletedIds, formationId]);

    newArray.splice(i, 1);
    setFormations(newArray);
  };

  const Valider = () => {
    let verifiedData = verifyData();
    if (verifiedData && errorMessageEndDate.message === "") {
      setModified(false);
      updateExperience();
    }
  };

  const updateExperience = async () => {
    //? Remove id de l'objet props.user et modification des dates de l'objet
    let formationsObj = [];
    for (let i = 0; i < formations.length; i++) {
      if (formations[i]?.startDate?.length < 8)
        formations[i].startDate = changeOrderDate(formations[i].startDate);
      if (formations[i]?.endDate?.length < 8)
        formations[i].endDate = changeOrderDate(formations[i].endDate);
      formationsObj.push(formations[i]);
    }

    let educationObject = {
      educations: [...formations],
    };

    //? Ajout des id des formations supprimées
    if (deletedIds.length > 0)
      educationObject.educations = {
        ...educationObject.educations,
        ...deletedIds.map((id) => ({ id, deleted: true })),
      };

    const cVId = props.auth.userConnected.resume.id;
    const userId = props.auth.userConnected.id;

    const updatedUser = await fetchPut(`/cvs/${cVId}`, educationObject);
    if (updatedUser.error) {
      errorToast(
        updatedUser.error.response?.data?.detail || "Une erreur est survenue"
      );
      return;
    }

    const newExperiences = Object.values(updatedUser.data.educations);
    props.handleUpdateEducation(newExperiences);
    setFormations(newExperiences);
    successToast("Votre mise à jour a bien été prise en compte");

    const completionRate = await fetchGet(
      `/users/${userId}/profile_completion_rate`
    );
    if (completionRate.error) {
      errorToast(
        completionRate.error.response?.data?.detail || "Une erreur est survenue"
      );
      return;
    }

    props.handleUpdateCompletionLevel(completionRate.data);
  };

  const findObject = (criteria, value) => {
    if (criteria === "studyLevel") {
      return diplomaData.data.find((diplome) => diplome.label === value);
    } else {
      return domainData.data.find((secteur) => secteur.label === value);
    }
  };

  //? Fonction qui permet de comparer si la date de début est antérieure à la date de fin et gérer les messages d'erreurs pour l'utilisateur
  const handleDateChange = (
    dateModified,
    startDate,
    endDate,
    indexFormation
  ) => {
    if (startDate !== null && endDate !== null) {
      if (dateModified === "end") {
        majFormation(
          new Date(endDate).toLocaleDateString("en-US"),
          indexFormation,
          "endDate"
        );
      } else {
        majFormation(
          new Date(startDate).toLocaleDateString("en-US"),
          indexFormation,
          "startDate"
        );
      }
      if (new Date(startDate) < new Date(endDate)) {
        setErrorMessageEndDate({
          index: indexFormation,
          message: "",
        });
      } else {
        setErrorMessageEndDate({
          message: "La date de début doit être antérieure à la date de fin",
          index: indexFormation,
        });
      }
    } else if (startDate !== null) {
      majFormation(
        new Date(startDate).toLocaleDateString("en-US"),
        indexFormation,
        "startDate"
      );
    } else {
      setErrorMessageEndDate({
        message: "Veuillez remplir une date de début d'expérience",
        index: indexFormation,
      });
    }
  };
  return (
    <div>
      <Toast ref={successUpdate} />
      {props.auth.isConnected && (
        <div className="article_actu">
          <NavBarTab
            id="desktop"
            select="profiledit"
            activeIndex={props.activeIndex}
            items={props.items}
          />
          <BtnEcouteMarche items={props.items} />

          <div className="titre_de_page">
            <h1 className="h1_trait_dessus">
              Modifier mes {props.items[props.activeIndex].label}
            </h1>
            <BtnRetour />
          </div>

          <div className="form-demo">
            <div className="card" key={modified}>
              {formations.length > 0 &&
              domainData.loaded &&
              diplomaData.loaded &&
              modified
                ? formations
                    .filter((formation) => !formation?.certified)
                    .map((formation, indexFormations) => {
                      const arrayIndex = formations.findIndex(
                        (f) => f === formation
                      );
                      return (
                        <div key={formation}>
                          <div className="form_bouton_suppr">
                            <h1>Formation {indexFormations + 1}</h1>
                            <BtnBlanc
                              btnAction={() => {
                                supprFormation(arrayIndex, formation.id);
                              }}
                            >
                              <FaTrash />
                            </BtnBlanc>
                          </div>
                          <div className="form_columns">
                            <div className="field" style={{ width: "100%" }}>
                              <h2>Titre de la formation *</h2>
                              <InputText
                                id="diploma"
                                placeholder="Master Droit international"
                                key={formation}
                                value={formation.diploma}
                                onChange={(e) =>
                                  majFormation(e, arrayIndex, "diploma")
                                }
                                required
                              />
                              {(formation.diploma == "" ||
                                formation.diploma == null) &&
                                validated && (
                                  <label className="validation">
                                    Le titre de la formation doit être renseigné
                                  </label>
                                )}
                            </div>
                          </div>
                          <div className="form_columns">
                            <div className="field">
                              <h2>Date de début *</h2>
                              <MuiPickersUtilsProvider
                                utils={DateFnsUtils}
                                locale={fr}
                              >
                                <DatePicker
                                  label="Date de début"
                                  selected={
                                    formation.startDate === null
                                      ? "09/2022"
                                      : formatDateWihoutDays(
                                          formation.startDate
                                        )
                                  }
                                  onChange={
                                    (date) =>
                                      handleDateChange(
                                        "start",
                                        date,
                                        formation.endDate,
                                        arrayIndex
                                      )

                                    // setErrorMessageEndDate(""),
                                    // majFormation(
                                    //   new Intl.DateTimeFormat("fr-FR", {
                                    //     year: "numeric",
                                    //     month: "numeric",
                                    //   }).format(date, "MM/YYYY"),
                                    //   indexFormations,
                                    //   "startDate"
                                    // )
                                  }
                                  labelFunc={() =>
                                    formation.startDate !== "" &&
                                    formation.startDate !== null
                                      ? formatDateWihoutDays(
                                          formation.startDate
                                        )
                                      : "09/2019..."
                                  }
                                  views={["year", "month"]}
                                  cancelLabel="Annuler"
                                />
                              </MuiPickersUtilsProvider>
                              {formation.startDate == null && validated && (
                                <label className="validation">
                                  La date de début doit être renseignée
                                </label>
                              )}
                            </div>
                            {!formation.current && (
                              <div className="field">
                                <h2>Date de fin *</h2>
                                <MuiPickersUtilsProvider
                                  utils={DateFnsUtils}
                                  locale={fr}
                                >
                                  <DatePicker
                                    label="Date de fin"
                                    placeholderText="09/2022"
                                    selected={
                                      formation.endDate === ""
                                        ? formatDateWihoutDays(Date.now())
                                        : formatDateWihoutDays(
                                            formation.endDate
                                          )
                                    }
                                    onChange={(date) =>
                                      handleDateChange(
                                        "end",
                                        formation.startDate,
                                        date,
                                        arrayIndex
                                      )
                                    }
                                    maxDate={Date.now()}
                                    labelFunc={() =>
                                      formation.endDate !== "" &&
                                      formation.endDate !== null
                                        ? formatDateWihoutDays(
                                            formation.endDate
                                          )
                                        : "09/2019..."
                                    }
                                    views={["year", "month"]}
                                    cancelLabel="Annuler"
                                  />
                                </MuiPickersUtilsProvider>
                                {formation.endDate == null && validated ? (
                                  <label className="validation">
                                    La date de fin doit être renseignée
                                  </label>
                                ) : (
                                  ""
                                )}
                                {errorMessageEndDate.message !== "" &&
                                  errorMessageEndDate.index == arrayIndex && (
                                    <p className="errorMessageEndDate">
                                      {errorMessageEndDate.message}
                                    </p>
                                  )}
                              </div>
                            )}
                          </div>
                          <div className="form_columns">
                            <div className="field">
                              <h2>Établissement *</h2>
                              <InputText
                                id="school"
                                placeholder="Université..."
                                key={indexFormations}
                                value={formation.school}
                                onChange={(e) =>
                                  majFormation(e, arrayIndex, "school")
                                }
                                required
                              />
                              {formation.school == "" && validated && (
                                <label className="validation">
                                  L&apos;établissement doit être renseigné
                                </label>
                              )}
                            </div>
                            <div className="field">
                              <h2>Ville de formation *</h2>
                              <InputText
                                id="title"
                                placeholder="Paris"
                                key={indexFormations}
                                value={formation.city}
                                onChange={(e) =>
                                  majFormation(e, arrayIndex, "city")
                                }
                                // options={diplomaData}
                                required
                              />
                              {formation.city == "" && validated && (
                                <label className="validation">
                                  La ville doit être renseignée
                                </label>
                              )}
                            </div>
                          </div>
                          <div className="form_columns">
                            <div className="field">
                              <h2>Niveau de diplôme *</h2>
                              <Dropdown
                                id="studyLevel"
                                placeholder="Bac+2..."
                                key={indexFormations}
                                value={findObject(
                                  "studyLevel",
                                  formation.studyLevel
                                )}
                                onChange={(e) =>
                                  majFormation(e, arrayIndex, "studyLevel")
                                }
                                options={diplomaData.data}
                                required
                              />
                              {(formation.studyLevel == null ||
                                formation.studyLevel == "") &&
                                validated && (
                                  <label className="validation">
                                    Le niveau de diplôme doit être renseigné
                                  </label>
                                )}
                            </div>
                            <div className="field">
                              <h2>Secteur de la formation *</h2>
                              <Dropdown
                                id="domain"
                                placeholder="Lettres, Sciences..."
                                key={indexFormations}
                                value={findObject("domain", formation.domain)}
                                options={domainData.data}
                                onChange={(e) =>
                                  majFormation(e, arrayIndex, "domain")
                                }
                                required
                              />
                              {formation.domain == null && validated && (
                                <label className="validation">
                                  Le secteur de la formation doit être renseigné
                                </label>
                              )}
                            </div>
                          </div>
                          <div className="field">
                            <Checkbox
                              label="current"
                              key={indexFormations}
                              checked={formation.current}
                              onChange={(e) =>
                                majFormation(e, arrayIndex, "current")
                              }
                            />

                            <label htmlFor="current">
                              Il s&apos;agit de ma formation actuelle
                            </label>
                          </div>
                          {/* formationVerif */}
                          <div></div>
                        </div>
                      );
                    })
                : formations
                    ?.sort(
                      (a, b) => new Date(a?.startDate) - new Date(b?.startDate)
                    )
                    ?.sort(
                      (a, b) =>
                        new Date(a?.endDate || Date.now()) -
                        new Date(b?.endDate || Date.now())
                    )
                    ?.sort((a, b) => a?.current - b?.current)
                    .map((formation, indexFormations) => {
                      if (formation?.certified) {
                        return (
                          <div
                            className="experience"
                            key={formation + modified}
                          >
                            {/* Seuls les diplômes obtenus sont considérés comme certifié */}
                            {formation?.obtainedDiplome && (
                              <img src={crown} alt="couronne" />
                            )}
                            <h4>
                              {formation.current
                                ? formation?.currentEtape?.label
                                : formation?.obtainedDiplome?.label}
                            </h4>
                            <p>
                              {formation.current
                                ? "En cours"
                                : formation?.startDate
                                ? new Date(
                                    formation?.startDate
                                  )?.getFullYear() +
                                  " - " +
                                  new Date(formation?.endDate)?.getFullYear()
                                : new Date(formation?.endDate)?.getFullYear()}
                            </p>
                            <div className="profil_show__container__article__container__experience__item">
                              <p>{props.auth.universityConnected?.label}</p>
                              <br />
                              {formations[indexFormations].domain?.label}
                            </div>
                          </div>
                        );
                      } else
                        return (
                          <div
                            className="experience"
                            key={formation + modified}
                          >
                            <h4>{formations[indexFormations].diploma}</h4>
                            <p>
                              {formatDateWihoutDays(
                                formations[indexFormations].startDate
                              )}{" "}
                              -{" "}
                              {formations[indexFormations].current
                                ? "Aujourd'hui"
                                : formatDateWihoutDays(
                                    formations[indexFormations].endDate
                                  )}
                            </p>
                            <div className="profil_show__container__article__container__experience__item">
                              {formations[indexFormations].school} -{" "}
                              {formations[indexFormations].city}
                              <br />
                              {formations[indexFormations].domain?.label}
                            </div>
                            <p>
                              <span>
                                Niveau
                                <span> </span>
                                {formations[indexFormations].studyLevel
                                  ?.label ||
                                  formations[indexFormations].studyLevel}
                              </span>
                            </p>
                          </div>
                        );
                    })}
              <div className="form_boutons" id="form_boutons">
                {modified ? (
                  <>
                    <div
                      className="form_bouton_add"
                      onClick={() => checkFormationBeforeAdd()}
                    >
                      <i className="pi pi-plus-circle" size="2rem" />
                      <label>Ajouter une formation</label>
                    </div>
                    <div>
                      <BtnBleuLeft btnTexte="Valider " btnAction={Valider}>
                        <FaCheck />
                      </BtnBleuLeft>
                    </div>
                  </>
                ) : (
                  <BtnBlancLeft
                    btnTexte="Modifier "
                    btnAction={() => setModified(true)}
                  >
                    <FaPen />
                  </BtnBlancLeft>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

FormationDiplomes.propTypes = {
  auth: PropTypes.object,
  secondaryTables: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  handleUpdateEducation: PropTypes.func,
  handleUpdateCompletionLevel: PropTypes.func,
  handleUpdateSecondaryTables: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateEducation: (value) => {
    dispatch(updateEducation(value));
  },
  handleUpdateCompletionLevel: (value) => {
    dispatch(updateCompletionLevel(value));
  },
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormationDiplomes);
